import { render, staticRenderFns } from "./selectCommunity.vue?vue&type=template&id=6473cc24&scoped=true&"
import script from "./selectCommunity.vue?vue&type=script&lang=js&"
export * from "./selectCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473cc24",
  null
  
)

export default component.exports